<h4>Aktuelle Spiele</h4>
<p *ngIf="events?.length === 0">Keine Spiele vorhanden</p>
<lib-games-list *ngIf="events?.length > 0"
                [events]="events"
                [openLinksInNewTab]="openLinksInNewTab"
                [highlightOnHover]="false"></lib-games-list>
<a mat-raised-button *ngIf="gamesLink" [href]="gamesLink">
  Zum Spielplan
</a>
